import React, { useState, useEffect, useRef } from 'react';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;

function MapaEmbarque({ passagem, origem, tipo }) {
    const mapRef = useRef(null);
    const [position, setPosition] = useState([-23.5505, -46.6333]);
    
    useEffect(() => {
        if (passagem && passagem.longitudeOrigem && passagem.latitudeOrigem) {
            const lat = tipo === 'origem' ? Number(passagem.longitudeOrigem) : Number(passagem.longitudeDestino);
            const lng = tipo === 'origem' ? Number(passagem.latitudeOrigem) : Number(passagem.latitudeDestino);
                                    
            if (!isNaN(lat) && !isNaN(lng)) {
                setPosition([lat, lng]);

                // 2. Acessa a instância do Leaflet para corrigir o render
                if (mapRef.current) {
                    const leafletMap = mapRef.current.leafletElement;
                    
                    // O setTimeout garante que o mapa recalcule o tamanho 
                    // APÓS o container estar visível e com dimensões finais
                    setTimeout(() => {
                        leafletMap.invalidateSize();
                        leafletMap.setView([lat, lng], 15);
                    }, 200);
                }
            }
        }        
    }, [passagem]);

    return (
        <div className='renderMapa'>
            <Map 
                ref={mapRef}
                center={position} 
                zoom={13} 
                style={{ height: '100%', width: '100%' }}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; OpenStreetMap contributors'
                />
                <Marker position={position}>
                    <Popup>
                        Localização de Origem: <br /> 
                        {origem && origem.nome} - {origem && origem.uf}
                    </Popup>
                </Marker>
            </Map>
        </div>
    );
}

export { MapaEmbarque };